<div>
  <div class="card card-border"  *ngIf="showDugSearchDetailData" #printComp>
    <div class="card-body">
      <div class="row" >
        <div class=" col col-xs-4  col-sm-4 col-md-4 col-lg-4">
          <p class="h8">{{labelName}}</p>
        </div>
        <div class=" col col-xs-1  col-sm-1 col-md-1 col-lg-1">
  
        </div>
        <div class=" col col-xs-5  col-sm-5 col-md-5 col-lg-5">
          <div *ngFor="let tccDetails of  drugDetails.tccDetails">
            <span>{{ tccDetails.therCat1Nm }} - {{ tccDetails.therClass1Nm }}</span>
            <span *ngIf="tccDetails.therCat1MbrGuiNm || tccDetails.therClass1MbrGuiNm">({{ tccDetails.therCat1MbrGuiNm }} - {{ tccDetails.therClass1MbrGuiNm }})</span>
          </div>
        </div>
        <div class=" col col-xs-2  col-sm-2 col-md-2 col-lg-2 doNotPrint">
          <button type="button" class="btn btn-primary" (click)="printComponent()">Print these results</button>
        </div>
      </div>
      <div class="row">
        <div class=" col col-xs-12  col-sm-12 col-md-12 col-lg-12">
          <p class="h8 align-heading"><b>Coverage:</b></p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-1 col-lg-1">
        </div>
        <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
          <div *ngFor="let ftTieringDetail of this.flTabDetails[0].formularyTieringDetails.tieringDetails">
            <div *ngIf="this.flTabDetails[0].urlDisplayCode === '1'">
             Tier {{ftTieringDetail.tierValue}}
            </div>
            <div *ngIf="this.flTabDetails[0].urlDisplayCode === '2'">
              {{ftTieringDetail.tierDescription}}
            </div>
            <div *ngIf="this.flTabDetails[0].urlDisplayCode === '3'">
              Tier {{ftTieringDetail.tierValue}} - {{ftTieringDetail.tierDescription}}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class=" col col-xs-12  col-sm-12 col-md-12 col-lg-12">
          <p class="h8 align-heading"><b>Restrictions:</b></p>
        </div>
      </div>
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let paTabDetail of paTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
            <mat-icon [ngClass]="paTabDetail.cmsTypeCode == 3 ? 'disbleclick' : ''"  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandPATreeLeaf( i, paTabDetail, arrowFlagPA)"><span id="{{pIndex +'-paDetail-'+i}}" >  keyboard_arrow_right </span>  </mat-icon>
            <span class="h8" *ngIf="paTabDetail.cmsTypeCode != '3'"> {{paTabDetail.classificationName }}</span>
            <span class="h8" *ngIf="paTabDetail.cmsTypeCode == '3'">  Prior Authorization – BvD </span>
            <ul  id="{{ pIndex + '-paIndicator-'+i }}"  class="nested align-tree-li"  *ngIf="(paTabDetail.urlDisplayCode == '1' || paTabDetail.urlDisplayCode == '3') && paTabDetail.lobId == 6">
              <li *ngIf="paTabDetail.paIndicator != null">PA Indication Indicator: {{paTabDetail.paIndicator}}</li>
              <li *ngIf="paTabDetail.paIndicator == null">PA Indication Indicator: N/A</li>
            </ul>
            <ul id="{{ pIndex + '-offLabelUses-'+i }}"  class="nested align-tree-li"  *ngIf="paTabDetail.urlDisplayCode == '1' || paTabDetail.urlDisplayCode == '3'">
              <li *ngIf="paTabDetail.priorAuthrorizationDetails.offLabelUses != null">Off-Label Uses: {{paTabDetail.priorAuthrorizationDetails?.offLabelUses}}</li>
              <li *ngIf="paTabDetail.priorAuthrorizationDetails.offLabelUses == null">Off-Label Uses: N/A</li>
            </ul>
            <ul id="{{ pIndex + '-exclusionCriteria-'+i }}"  class="nested align-tree-li"  *ngIf="paTabDetail.urlDisplayCode == '1' || paTabDetail.urlDisplayCode == '3'">
              <li *ngIf="paTabDetail.priorAuthrorizationDetails?.exclusionCriteria != null">Exclusion Criteria: {{paTabDetail.priorAuthrorizationDetails?.exclusionCriteria}}</li>
              <li *ngIf="paTabDetail.priorAuthrorizationDetails?.exclusionCriteria == null">Exclusion Criteria: N/A</li>
            </ul>
            <ul id="{{ pIndex + '-requiredMedicalInformation-'+i }}"  class="nested align-tree-li"  *ngIf="paTabDetail.urlDisplayCode == '1' || paTabDetail.urlDisplayCode == '3'">
              <li *ngIf="paTabDetail.priorAuthrorizationDetails?.requiredMedicalInformation !=null">Required Medical Information: {{paTabDetail.priorAuthrorizationDetails?.requiredMedicalInformation}}</li>
              <li *ngIf="paTabDetail.priorAuthrorizationDetails?.requiredMedicalInformation ==null">Required Medical Information: N/A</li>
            </ul>
            <ul id="{{pIndex + '-ageRestrictions-'+i }}"  class="nested align-tree-li"  *ngIf="paTabDetail.urlDisplayCode == '1' || paTabDetail.urlDisplayCode == '3'">
              <li *ngIf="paTabDetail.priorAuthrorizationDetails?.ageRestrictions != null">Age Restrictions: {{paTabDetail.priorAuthrorizationDetails?.ageRestrictions}}</li>
              <li *ngIf="paTabDetail.priorAuthrorizationDetails?.ageRestrictions == null">Age Restrictions: N/A</li>
            </ul>
            <ul id="{{ pIndex + '-prescriberRestrictions-'+i }}"  class="nested align-tree-li"  *ngIf="paTabDetail.urlDisplayCode == '1' || paTabDetail.urlDisplayCode == '3'">
              <li *ngIf="paTabDetail.priorAuthrorizationDetails?.prescriberRestrictions != null">Prescriber Restrictions: {{paTabDetail.priorAuthrorizationDetails?.prescriberRestrictions}}</li>
              <li *ngIf="paTabDetail.priorAuthrorizationDetails?.prescriberRestrictions == null">Prescriber Restrictions: N/A</li>
            </ul>
            <ul id="{{ pIndex + '-coverageDuration-'+i }}"  class="nested align-tree-li"  *ngIf="paTabDetail.urlDisplayCode == '1' || paTabDetail.urlDisplayCode == '3'">
              <li *ngIf="paTabDetail.priorAuthrorizationDetails?.coverageDuration!=null">Coverage Duration: {{paTabDetail.priorAuthrorizationDetails?.coverageDuration}}</li>
              <li *ngIf="paTabDetail.priorAuthrorizationDetails?.coverageDuration==null">Coverage Duration: N/A</li>
            </ul>
            <ul id="{{ pIndex + '-otherCriteria-'+i }}"  class="nested align-tree-li"  *ngIf="paTabDetail.urlDisplayCode == '1' || paTabDetail.urlDisplayCode == '3'">
              <li *ngIf="paTabDetail.priorAuthrorizationDetails?.otherCriteria !=null">Other Criteria: {{paTabDetail.priorAuthrorizationDetails?.otherCriteria}}</li>
              <li *ngIf="paTabDetail.priorAuthrorizationDetails?.otherCriteria ==null">Other Criteria: N/A</li>
            </ul>
            <ul id="{{ pIndex + '-partbPreReqCode-'+i }}"  class="nested align-tree-li"  *ngIf="(paTabDetail.urlDisplayCode == '1' || paTabDetail.urlDisplayCode == '3')  && paTabDetail.lobId == 6">
              <li *ngIf="paTabDetail.partbPreReqCode != null">Part B Prerequisite: {{paTabDetail.partbPreReqCode}}</li>
              <li *ngIf="paTabDetail.partbPreReqCode == null">Part B Prerequisite: N/A</li>
            </ul>
            <ul id="{{ pIndex + '-pamemberMessaging-'+i }}"  class="nested align-tree-li"  *ngIf="paTabDetail.urlDisplayCode == '2' || paTabDetail.urlDisplayCode == '3'">
              <li *ngIf="paTabDetail.memberMessaging != null">Member Messaging: {{paTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let qlTabDetail of qlTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
              (click)="expandqlTreeLeaf( i, qlTabDetail, arrowFlagQL)"><span id="{{pIndex +'-qlDetail-'+i}}">keyboard_arrow_right</span></mat-icon>
            <span class="h8"> {{qlTabDetail.classificationName}}</span> 
            <ul id="{{ pIndex +'-quantityLimitAmount-'+i }}"  class="nested align-tree-li"  *ngIf="qlTabDetail.urlQLProgramDisplayCode == '1' || qlTabDetail.urlQLProgramDisplayCode == '3'">
              <li>{{qlTabDetail.quantityLimit.quantityLimitAmount}} {{qlTabDetail.quantityLimit.quantityLimitOfMeasure}} / {{qlTabDetail.quantityLimit.quantityLimitLength}} {{qlTabDetail.quantityLimit.quantityLimitPeriodOfTime}}</li>
            </ul>
            <ul id="{{ pIndex +'-qlmemberMessaging-'+i }}"  class="nested align-tree-li"  *ngIf="qlTabDetail.urlQLProgramDisplayCode == '2' || qlTabDetail.urlQLProgramDisplayCode == '3'">
              <li *ngIf="qlTabDetail.memberMessaging !=null && qlTabDetail.memberMessaging != 'N/A'">{{qlTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let stTabDetail of stTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandSTTreeLeaf( i, stTabDetail, arrowFlagST)"><span id="{{pIndex +'-stDetail-'+i}}">  keyboard_arrow_right </span>  </mat-icon>
            
            <span class="h8">{{stTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-stDetailMem-'+i }}"  class="nested align-tree-li" *ngIf="stTabDetail.urlSTProgramDisplayCode == '1'">
              <li>{{stTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let acaTabDetail of acaTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf( i,'aca',acaTabDetail,arrowFlagACA)"><span id="{{pIndex +'-acaDetail-'+i}}">  keyboard_arrow_right </span>  </mat-icon>
            <span class="h8"> {{acaTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-acaDetailMem-'+i }}"  class="nested align-tree-li" *ngIf="acaTabDetail.urlDisplayCode == '1'">
              <li>{{acaTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let ageTabDetail of ageTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'age',ageTabDetail,arrowFlagAge)"><span id="{{ pIndex+'-ageDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
            <span class="h8"> {{ageTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-ageDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="ageTabDetail.urlDisplayCode == '1'">
              <li>{{ageTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let bhrsTabDetail of bhrsTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>           
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'bhrs',bhrsTabDetail,arrowFlagBhrs)"><span id="{{ pIndex+'-bhrsDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
           
            <span class="h8"> {{bhrsTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-bhrsDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="bhrsTabDetail.urlDisplayCode == '1'">
              <li>{{bhrsTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let code1TabDetail of code1TabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'code1',code1TabDetail,arrowFlagcode1)"><span id="{{ pIndex+'-code1Detail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
           
           
            <span class="h8"> {{code1TabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-code1DetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="code1TabDetail.urlDisplayCode == '1'">
              <li>{{code1TabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let dlTabDetail of dlTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
           
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'dl',dlTabDetail,arrowFlagdl)"><span id="{{ pIndex+'-dlTabDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
            <span class="h8"> {{dlTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-dlDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="dlTabDetail.urlDisplayCode == '1'">
              <li>{{dlTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let exdTabDetail of exdTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
           
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'exd',exdTabDetail,arrowFlagexd)"><span id="{{ pIndex+'-exdDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
          
            <span class="h8"> {{exdTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-exdDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="exdTabDetail.urlDisplayCode == '1'">
              <li>{{exdTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
  
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let fffTabDetail of fffTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'fff',fffTabDetail,arrowFlagfff)"><span id="{{ pIndex+'-fffDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
          
            <span class="h8"> {{fffTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-fffDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="fffTabDetail.urlDisplayCode == '1'">
              <li>{{fffTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
  
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let fabTabDetail of fabTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>         
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'fab',fabTabDetail,arrowFlagfab)"><span id="{{ pIndex+'-fabDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
          
            <span class="h8"> {{fabTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-fabDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="fabTabDetail.urlDisplayCode == '1'">
              <li>{{fabTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
  
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let gapTabDetail of gapTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
            
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'gap',gapTabDetail,arrowFlaggap)"><span id="{{ pIndex+'-gapDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
          

            <span class="h8"> {{gapTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-gapDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="gapTabDetail.urlDisplayCode == '1'">
              <li>{{gapTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
  
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let genderTabDetail of genderTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
            

            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'gender',genderTabDetail,arrowFlaggender)"><span id="{{ pIndex+'-genderDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
          

            <span class="h8"> {{genderTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-genderDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="genderTabDetail.urlDisplayCode == '1'">
              <li>{{genderTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
  
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let hcTabDetail of hcTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
            
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'hc',hcTabDetail,arrowFlaghc)"><span id="{{ pIndex+'-hcDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
         

            <span class="h8"> {{hcTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-hcDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="hcTabDetail.urlDisplayCode == '1'">
              <li>{{hcTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
  
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let hiTabDetail of hiTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
          
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'hi',hiTabDetail,arrowFlaghi)"><span id="{{ pIndex+'-hiDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
         
            <span class="h8"> {{hiTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-hiDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="hiTabDetail.urlDisplayCode == '1'">
              <li>{{hiTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
  
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let ispTabDetail of ispTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>           
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'isp',ispTabDetail,arrowFlagisp)"><span id="{{ pIndex+'-ispDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
            <span class="h8"> {{ispTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-ispDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="ispTabDetail.urlDisplayCode == '1'">
              <li>{{ispTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
  
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let laTabDetail of laTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
          
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'la',laTabDetail,arrowFlagla)"><span id="{{ pIndex+'-laDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
            
            <span class="h8"> {{laTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-laDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="laTabDetail.urlDisplayCode == '1'">
              <li>{{laTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
  
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let laoTabDetail of laoTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'lao',laoTabDetail,arrowFlaglao)"><span id="{{ pIndex+'-laoDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>   
            
            <span class="h8"> {{laoTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-laoDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="laoTabDetail.urlDisplayCode == '1'">
              <li>{{laoTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
  
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let moTabDetail of moTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'mo',moTabDetail,arrowFlagmo)"><span id="{{ pIndex+'-moDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
           

            <span class="h8"> {{moTabDetail.classificationName}}</span>
            <ul id="{{ pIndex+'-moDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="moTabDetail.urlDisplayCode == '1'">
              <li>{{moTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
  
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let maintanaceTabDetail of maintanaceTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
          
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'maintanace',maintanaceTabDetail,arrowFlagmaintanace)"><span id="{{ pIndex+'-maintanaceDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
           <span class="h8"> {{maintanaceTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-maintanaceDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="maintanaceTabDetail.urlDisplayCode == '1'">
              <li>{{maintanaceTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
  
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let mabTabDetail of mabTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'mab',mabTabDetail,arrowFlagmab)"><span id="{{ pIndex+'-mabDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
         
            <span class="h8"> {{mabTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-mabDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="mabTabDetail.urlDisplayCode == '1'">
              <li>{{mabTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
  
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let npdTabDetail of npdTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
           
           
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'npd',npdTabDetail,arrowFlagnpd)"><span id="{{ pIndex+'-npdDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
         
            <span class="h8"> {{npdTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-npdDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="npdTabDetail.urlDisplayCode == '1'">
              <li>{{npdTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
  
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let ndsTabDetail of ndsTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
           
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'nds', ndsTabDetail, arrowFlagnds)"><span id="{{ pIndex+'-ndsDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
         
            <span class="h8"> {{ndsTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-ndsDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="ndsTabDetail.urlDisplayCode == '1'">
              <li>{{ndsTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
  
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let oacTabDetail of oacTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
            
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'oac',oacTabDetail, arrowFlagoac)"><span id="{{ pIndex+'-oacDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
         
            <span class="h8"> {{oacTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-oacDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="oacTabDetail.urlDisplayCode == '1'">
              <li>{{oacTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
  
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let otherTabDetail of otherTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
           
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'other',otherTabDetail, arrowFlagother)"><span id="{{ pIndex+'-otherDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
         
            <span class="h8"> {{otherTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-otherDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="otherTabDetail.urlDisplayCode == '1'">
              <li>{{otherTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
  
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let otcTabDetail of otcTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'otc',otcTabDetail, arrowFlagotc)"><span id="{{ pIndex+'-otcDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
         
            <span class="h8"> {{otcTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-otcDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="otcTabDetail.urlDisplayCode == '1'">
              <li>{{otcTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
  
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let partbTabDetail of partbTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
            
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'partb',partbTabDetail, arrowFlagpartb)"><span id="{{ pIndex+'-partbDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
         
          
          
            <span class="h8"> {{partbTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-partbDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="partbTabDetail.urlDisplayCode == '1'">
              <li>{{partbTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
  
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let pdTabDetail of pdTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
          
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'pd',pdTabDetail, arrowFlagpd)"><span id="{{ pIndex+'-pdDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
         
            <span class="h8"> {{pdTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-pdDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="pdTabDetail.urlDisplayCode == '1'">
              <li>{{pdTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
  
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let pgTabDetail of pgTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
            
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'pg',pgTabDetail, arrowFlagpg)"><span id="{{ pIndex+'-pgDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
         
            <span class="h8"> {{pgTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-pgDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="pgTabDetail.urlDisplayCode == '1'">
              <li>{{pgTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
  
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let pdcTabDetail of pdcTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
         
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'pdc',pdcTabDetail, arrowFlagpdc)"><span id="{{ pIndex+'-pdcDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
         
            <span class="h8"> {{pdcTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-pdcDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="pdcTabDetail.urlDisplayCode == '1'">
              <li>{{pdcTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
  
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let rebateTabDetail of rebateTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
           
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'rebate',rebateTabDetail, arrowFlagrebate)"><span id="{{ pIndex+'-rebateDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
         
            <span class="h8"> {{rebateTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-rebateDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="rebateTabDetail.urlDisplayCode == '1'">
              <li>{{rebateTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
  
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let saoTabDetail of saoTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
           
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'sao',saoTabDetail, arrowFlagsao)"><span id="{{ pIndex+'-saoDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
         
            <span class="h8"> {{saoTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-saoDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="saoTabDetail.urlDisplayCode == '1'">
              <li>{{saoTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
  
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let spTabDetail of spTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>            
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'sp',spTabDetail, arrowFlagsp)"><span id="{{ pIndex+'-spDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
         
            <span class="h8"> {{spTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-spDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="spTabDetail.urlDisplayCode == '1'">
              <li>{{spTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
  
      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let vbidTabDetail of vbidTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
          
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'vbid',vbidTabDetail, arrowFlagvbid)"><span id="{{ pIndex+'-vbidDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
         
            <span class="h8"> {{vbidTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-vbidDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="vbidTabDetail.urlDisplayCode == '1'">
              <li>{{vbidTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>

      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let siTabDetail of siTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
           
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'si',siTabDetail,arrowFlagdl)"><span id="{{ pIndex+'-siTabDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
            <span class="h8"> {{siTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-siDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="siTabDetail.urlDisplayCode == '1'">
              <li>{{siTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>

      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let partdTabDetail of partdTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
           
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'partd',partdTabDetail,arrowFlagdl)"><span id="{{ pIndex+'-partdTabDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
            <span class="h8"> {{partdTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-partdDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="partdTabDetail.urlDisplayCode == '1'">
              <li>{{partdTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>

      <div class=" col col-xs-11  col-sm-11 col-md-11 col-lg-11">
        <ul  id="myUL" *ngFor="let zdvTabDetail of zdvTabDetails;let i=index" style="padding-bottom: 1%;">
          <li>
           
            <mat-icon  class="default-color arrowStyle"  aria-hidden="false" aria-label="Arrow icon" 
            (click)="expandOtherTreeLeaf(i,'zdv',zdvTabDetail,arrowFlagdl)"><span id="{{ pIndex+'-zdvTabDetail-'+i }}">  keyboard_arrow_right </span>  </mat-icon>
            <span class="h8"> {{zdvTabDetail.classificationName}}</span>
            <ul id="{{ pIndex +'-zdvDetailMem-'+i }}"  class="nested align-tree-li"  *ngIf="zdvTabDetail.urlDisplayCode == '1'">
              <li>{{zdvTabDetail.memberMessaging}}</li>
            </ul>
          </li>
        </ul>
      </div>
  
    </div>

    <div class="row align-alternative" *ngIf="displayAlternativesButton && planDetails?.drugSearchType != 'searchByDrugClass'">
      <div class=" col col-xs-12  col-sm-12 col-md-12 col-lg-12 doNotPrint">
        <button type="button" class="btn btn-primary"  (click)="showAlternatives('btnEvent')">Show Formulary Alternatives</button>
      </div>
    </div>
    <br>
  </div>
  </div>


  
  <div *ngIf="showAlternativeAlertMessage">
      <div class="alert alert-danger alert-dismissible fade show">
        <span>{{alertMessage}}</span>
        <button type="button" class="close" data-dismiss="alert" (click)="close()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
  </div>
  
  
  <ng-template #alternativesmodal let-modal class="doNotPrint">
    <br>
    <div class="row">
      <div class = "col col-xs-4  col-sm-4 col-md-4 col-lg-4">
      </div>
      <div class = "col col-xs-5  col-sm-5 col-md-5 col-lg-5">
        <p class="h4"><b>Formulary Alternatives</b></p>
      </div>
      <div class = "col col-xs-2  col-sm-2 col-md-2 col-lg-2">
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">×</span>
        </button>
      </div>
    </div>
    <div *ngIf="!showError">
    </div>
    <div class="card card-border">
    <div class="modal-body" (scroll)="scrollHandler($event)">
      <div class="alert alert-danger alert-dismissible" *ngIf="alternativeErrorMessage">
        <span>{{noAlternativesMessage}}</span>
      </div>
      <table class="table table-striped table-hover">
        <tr *ngFor="let drugSearchAlternative of validMatchingEntryList">
          <td style="width:40%">
            <span *ngIf="drugSearchAlternative.gpiCode === '2'" class="alternative-styling" (click)="modal.close('Save click');doCallBackFromAlternatives(drugSearchAlternative)">{{drugSearchAlternative.labelName | uppercase}}</span>
            <span *ngIf="drugSearchAlternative.gpiCode !== '2'" class="alternative-styling italic" (click)="modal.close('Save click');doCallBackFromAlternatives(drugSearchAlternative)">{{drugSearchAlternative.labelName | lowercase}}</span>
          </td>
          <td style="width:10%">
            <span> Tier {{drugSearchAlternative.tierValueCount}}</span>
          </td>
          <td style="width:50%" >
              <span> {{ drugSearchAlternative.programParticipation }}</span>
          </td>
        </tr>
      </table>
    </div>
    </div>
  </ng-template>